import { useTranslation } from 'react-i18next';
import { type IIdentifyLayerResult } from '../drawing/identify/IIdentifyResult.ts';

export interface IMapIdentifyLiveRegionProps {
  /** `null` = nessuna interrogazione eseguita, `[]` = eseguita senza risultati. */
  results: IIdentifyLayerResult[] | null;
  isLoading: boolean;
}

/**
 * Region `aria-live` sempre montata che annuncia agli screen reader l'esito
 * dell'interrogazione (identify). Deve restare persistente (non smontarsi con
 * il pannello) perché la modifica del testo venga rilevata e annunciata.
 */
export function MapIdentifyLiveRegion(props: IMapIdentifyLiveRegionProps) {
  const { results, isLoading } = props;
  const { t } = useTranslation();

  let announcement = '';
  if (!isLoading && results != null) {
    const total = results.reduce((sum, r) => sum + r.features.length, 0);
    announcement =
      total > 0
        ? t('mappa.identify.annuncio-risultati', {
            count: total,
            defaultValue: 'Interrogazione completata: {{count}} risultati',
          })
        : t('mappa.identify.nessun-risultato', {
            defaultValue: 'Nessun risultato trovato',
          });
  }

  // `<output>` ha implicitamente role="status" (live region "polite").
  return (
    <output className="sr-only" aria-live="polite">
      {announcement}
    </output>
  );
}
